// export const redirectToWhatsApp = ({ phone, message }) => {
//   const encodedMessage = encodeURIComponent(message);
//   const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

//   const whatsappAppUrl = `whatsapp://send?phone=${phone}&text=${encodedMessage}`;
//   const whatsappWebUrl = `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
//   const fallbackUrl = isMobile
//     ? `https://wa.me/${phone}?text=${encodedMessage}`
//     : whatsappWebUrl;

//   let fallbackWindow;

//   try {
//     const newWindow = window.open(whatsappAppUrl, "_blank");

//     setTimeout(() => {
//       if (
//         !newWindow ||
//         newWindow.closed ||
//         typeof newWindow.closed === "undefined"
//       ) {
//         fallbackWindow = window.open(fallbackUrl, "_blank");

//         setTimeout(() => {
//           if (
//             !fallbackWindow ||
//             fallbackWindow.closed ||
//             typeof fallbackWindow.closed === "undefined"
//           ) {
//             return;
//           }
//         }, 2000);
//       }
//     }, 2000);
//   } catch (err) {
//     alert("Something went wrong while trying to open WhatsApp.");
//   }
// };

export const redirectToWhatsApp = ({ phone, message }) => {
  const encodedMessage = encodeURIComponent(message);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const whatsappAppUrl = `whatsapp://send?phone=${phone}&text=${encodedMessage}`;
  const whatsappWebUrl = `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
  const waMeUrl = `https://wa.me/${phone}?text=${encodedMessage}`;

  if (isMobile) {
    // Try opening the WhatsApp app
    const appWindow = window.open(whatsappAppUrl, "_self");

    // Fallback to wa.me after short delay if app fails
    setTimeout(() => {
      const stillOnSamePage = document.hasFocus(); // crude check
      if (stillOnSamePage) {
        window.location.href = waMeUrl;
      }
    }, 1500);
  } else {
    // On desktop, just open WhatsApp Web
    window.open(whatsappWebUrl, "_blank");
  }
};

